import { TFunction } from 'i18next'
import TokenProfileRestService from '../rest/TokenProfileRestService'

class TokenProfileService {
  async getTokenProfiles(setTokenProfiles?: React.Dispatch<any>) {
    if (setTokenProfiles) {
      const tokenProfiles = await TokenProfileRestService.get()
      setTokenProfiles(tokenProfiles)
    } else {
      return TokenProfileRestService.get()
    }
  }

  async getConfigurableTokenProfiles(setTokenProfiles?: React.Dispatch<any>) {
    if (setTokenProfiles) {
      const tokenProfiles = await TokenProfileRestService.getAllConfigurable()
      setTokenProfiles(tokenProfiles)
    } else {
      return TokenProfileRestService.getAllConfigurable()
    }
  }

  async getTokenProfile(id: number, setTokenProfiles?: React.Dispatch<any>) {
    if (setTokenProfiles) {
      const tokenProfiles = await TokenProfileRestService.getById(id)
      setTokenProfiles(tokenProfiles)
    } else {
      return TokenProfileRestService.getById(id)
    }
  }

  async createTokenProfile(tokenProfile: any, forceUpdate: boolean, t: TFunction, setTokenProfiles?: React.Dispatch<any>) {
    try {
      const editedTokenProfile = await TokenProfileRestService.create(tokenProfile, forceUpdate)
      if (setTokenProfiles) {
        const tokenProfiles = await TokenProfileRestService.getAllConfigurable()
        setTokenProfiles(tokenProfiles)
      }
      return t('tokenProfile.createTokenProfileSuccess', { name: editedTokenProfile.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async deleteTokenProfile(tokenProfile: any, t: TFunction, setTokenProfiles?: React.Dispatch<any>) {
    try {
      await TokenProfileRestService.delete(tokenProfile.id)
      if (setTokenProfiles) {
        const tokenProfiles = await TokenProfileRestService.getAllConfigurable()
        setTokenProfiles(tokenProfiles)
      }
      return t('tokenProfile.deleteTokenProfileSuccess', { name: tokenProfile.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getDefinitions(setTokenProfileDefinition?: React.Dispatch<any>) {
    try {
      if (setTokenProfileDefinition) {
        const tokenProfileDefinition = await TokenProfileRestService.getDefinitions()
        if (tokenProfileDefinition) {
          setTokenProfileDefinition(tokenProfileDefinition)
        }
        return
      }
      return TokenProfileRestService.getDefinitions()
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default new TokenProfileService() as TokenProfileService
